/**
 * One colour per value type, shared by the editor's literal highlights and
 * the typeahead's type labels so the two always agree. The grammar has no
 * date literal yet; the date colour covers date-typed rows in the typeahead
 * (and literals if the grammar ever grows them).
 */
export const VALUE_TYPE_COLORS = {
  string: 'var(--mui-colors-success-70)',
  number: 'var(--mui-colors-tertiary-60)',
  date: 'var(--mui-colors-secondary-50)',
} as const;

/** The colour for a vocabulary type, or undefined for unmapped ones (list, boolean, …). */
export function valueTypeColor(type: string): string | undefined {
  return VALUE_TYPE_COLORS[type as keyof typeof VALUE_TYPE_COLORS];
}
